// Unused in all v2 components
export const AccuracyColors = {
  currentlyAssigned: '#dae7d3',
  accuracy0to50: '#900012',
  accuracy51to84: '#2452bb',
  accuracy85to100: '#008902'
};

export const ProgressColors = {
  currentlyAssigned: '#dae7d3',
  completed1to20: '#031c73',
  completed21to40: '#314eb5',
  completed41to60: '#0c80a3',
  completed61to80: '#0fc2a8',
  completed81to100: '#4bda40'
};

export const SCORE_BAND_TYPES = {
  DEFAULT: 'default',
  HOVER: 'hover'
}

export const ScoreBandColors = {
  currentlyAssigned: {
    [SCORE_BAND_TYPES.DEFAULT]: '#dae7d3',
    [SCORE_BAND_TYPES.HOVER]: 'rgb(229,229,229)'
  },
  completed1to20: {
    [SCORE_BAND_TYPES.DEFAULT]: '#c53902',
    [SCORE_BAND_TYPES.HOVER]: '#DAA18E'
  },
  completed21to40: {
    [SCORE_BAND_TYPES.DEFAULT]: '#e06d3f',
    [SCORE_BAND_TYPES.HOVER]: '#E8B9A4'
  },
  completed41to60: {
    [SCORE_BAND_TYPES.DEFAULT]: '#e89e13',
    [SCORE_BAND_TYPES.HOVER]: '#EECF9D'
  },
  completed61to80: {
    [SCORE_BAND_TYPES.DEFAULT]: '#81daab',
    [SCORE_BAND_TYPES.HOVER]: '#CAEBD6'
  },
  completed81to100: {
    [SCORE_BAND_TYPES.DEFAULT]: '#37c97c',
    [SCORE_BAND_TYPES.HOVER]: '#B3E2C1'
  }
}



// WEBPACK FOOTER //
// ./components/view-key/view-key-colors.js